import { Stack } from '@mantine/core'

import { InlineLink } from '../InlineLink/InlineLink'
import { Text } from '../Text/Text'
import { Title } from '../Title/Title'
import classes from './Disclaimer.module.css'
import type { DisclaimerProps } from './Disclaimer.types'

export function Disclaimer({
  description,
  icon,
  link,
  maxWidth = '100%',
  textVariant = 'body_2',
  title,
}: DisclaimerProps) {
  const className = icon ? classes.containerWithIcon : classes.container

  return (
    <Stack className={className} maw={maxWidth} mx="auto" w="100%">
      {icon && icon}
      {title && <Title variant="h4">{title}</Title>}
      {description && <Text variant={textVariant}>{description}</Text>}
      {link && (
        <InlineLink
          label={link.label}
          state={link.state}
          target={link.target}
        />
      )}
    </Stack>
  )
}
